import {AxisScale, TickFormatter} from '@visx/axis';
import {ScaleInput} from '@visx/scale';

import {UserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';

export interface AxisProps {
  scale: AxisScale;
  tickFormat?: TickFormatter<ScaleInput<AxisScale>>;
  hideTickValues?: boolean;
  numTicks?: number;
}

export const DEFAULT_TICK_LABEL_PROPS = {
  fontSize: 11,
  lineHeight: 13,
};

export const findTickLabelFillColor = (theme: UserTheme) => theme.greys.shade70;
